<div class="modal fade modal-full-width modal-full-height" aria-hidden="true"
    [class.atividade-concluida]="config?.isConcluida"
    [class.atividade-atrasada]="config?.isAtrasada"
    [class.atividade-pendente]="config?.isPendente">
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header modal-header-status" *ngIf="editMode">
                <h5 class="modal-title">
                    <span *ngIf="config?.isOrigemRetorno">
                        <i class="fas fa-retweet"></i> Atividade de Retorno
                    </span>
                    <span *ngIf="!config?.isOrigemRetorno">
                        Atividade
                    </span>
                    #{{entity?.id}}
                </h5>

                <h5 class="modal-title">
                    <span *ngIf="config?.isConcluida">Concluída</span>
                    <span *ngIf="config?.isAtrasada">Atrasada</span>
                    <span *ngIf="config?.isPendente">Pendente</span>
                </h5>
            </div>
            <div class="modal-header" *ngIf="!editMode">
                <h5 class="modal-title">
                    Nova atividade
                </h5>
            </div>

            <div class="modal-body">
                <form #form="ngForm" novalidate class="form">
                    <div *ngIf="entity">
                        <div class="row">
                            <div class="form-group col-12 col-md-6">
                                <sgt-atividade-tipo-select
                                    [ngModel]="entity.tipo"
                                    (ngModelChange)="onChangeTipo($event)"
                                    name="tipo"
                                    id="tipo_{{entity.id ? entity.id : 0}}"
                                    [disabled]="!canEditTipoFn()"
                                    [required]="true">
                                </sgt-atividade-tipo-select>


                                <h5 class="m-0" *ngIf="!canEditTipoFn()">
                                    <span class="badge badge-primary" title="Cadastro Novo" *ngIf="isTipoClienteRevisao() && entity.cliente?.cadastroNovo">
                                        <i class="fas fa-asterisk"></i> Cadastro Novo
                                    </span>
                                </h5>
                            </div>

                            <div class="form-group col-12 col-md-6">
                                <div class=" btn-group btn-group-flags">
                                    <button type="button" class="btn btn-light btn-sinalizado" [class.selected]="entity.sinalizado" title="Sinalizado"
                                        (click)="toggleSinalizado()">
                                        <i class="fas fa-flag" aria-hidden="true"></i>
                                    </button>
                                    <button type="button" class="btn btn-light btn-importante" [class.selected]="entity.importante" title="Importante"
                                        (click)="toggleImportante()">
                                        <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="row" *ngIf="isShowTitulo()">
                            <div class="form-group col-12">
                                <label for="titulo" class="col-form-label">Título</label>
                                <ng-template [ngIf]="canEditTitulo()">
                                    <input type="text" class="form-control" [(ngModel)]="entity.titulo" name="titulo" id="titulo_{{entity.id ? entity.id : 0}}"
                                        #titulo="ngModel" required="required">
                                    <p class="form-text text-muted">Informe um título para identificar a atividade</p>
                                    <sgt-form-control-error
                                        *ngIf="titulo.errors && titulo.errors.required && titulo.dirty"
                                        msgError="O título é obrigatório">
                                    </sgt-form-control-error>
                                </ng-template>
                                <ng-template [ngIf]="!canEditTitulo()">
                                    <input type="text" class="form-control" [value]="entity.titulo" disabled="disabled" readonly="readonly">
                                </ng-template>
                            </div>
                        </div>

                        <!-- Contato -->
                        <sgt-collapse-group title="Informações do Contato" [isCollapsedInDefault]="true" *ngIf="isTipoEntrarEmContato()">
                            <div class="row">
                                <div class="form-group col-12">
                                    <label class="col-form-label">Iniciativa</label>
                                    <sgt-contato-iniciativa-card-control-radio
                                        [(ngModel)]="entity.iniciativaContato"
                                        #iniciativaContato="ngModel"
                                        #iniciativaCardControlRadio
                                        name="iniciativaContato"
                                        id="iniciativaContato_{{entity.id ? entity.id : 0}}"
                                        [required]="true">
                                    </sgt-contato-iniciativa-card-control-radio>
                                    <p class="form-text text-muted">Iniciativa do contato</p>
                                    <sgt-form-control-error
                                       *ngIf="iniciativaContato.errors && iniciativaContato.errors.required && iniciativaContato.dirty"
                                       msgError="A iniciativa do contato é obrigatória">
                                   </sgt-form-control-error>
                                </div>
                            </div>
                            <div class="row">
                               <div class="form-group col-12 col-md">
                                   <label class="col-form-label">Tipo</label>
                                   <sgt-contato-tipo-select
                                       [(ngModel)]="entity.tipoContato"
                                       name="tipoContato"
                                       id="tipoContato_{{entity.id ? entity.id : 0}}"
                                       #tipoContato="ngModel"
                                       [required]="true">
                                   </sgt-contato-tipo-select>
                                   <p class="form-text text-muted">Tipo do contato</p>
                                   <sgt-form-control-error
                                       *ngIf="tipoContato.errors && tipoContato.errors.required && tipoContato.dirty"
                                       msgError="O tipo do contato é obrigatório">
                                   </sgt-form-control-error>
                               </div>
                               <div class="form-group col-12 col-md">
                                   <label class="col-form-label">Forma</label>
                                   <sgt-contato-forma-select
                                       [(ngModel)]="entity.formaContato"
                                       name="formaContato"
                                       id="formaContato_{{entity.id ? entity.id : 0}}"
                                       #formaContato="ngModel"
                                       [required]="true">
                                   </sgt-contato-forma-select>
                                   <p class="form-text text-muted">Forma do contato</p>
                                   <sgt-form-control-error
                                       *ngIf="formaContato.errors && formaContato.errors.required && formaContato.dirty"
                                       msgError="A forma do contato é obrigatória">
                                   </sgt-form-control-error>
                               </div>
                           </div>
                           <div class="row">
                               <div class="form-group col-12">
                                   <label for="motivoContato_{{entity.id ? entity.id : 0}}" class="col-form-label">Motivo</label>
                                   <sgt-motivo-perda-venda-select
                                       #motivoContatoSelect
                                       #motivoContato="ngModel"
                                       [(ngModel)]="entity.idMotivoContato"
                                       name="motivoContato"
                                       id="motivoContato_{{entity.id ? entity.id : 0}}"
                                       required="required"
                                       [canSelectNull]="false"
                                       [somenteAtivos]="true"
                                       [contatoCliente]="true">
                                   </sgt-motivo-perda-venda-select>
                                   <p class="form-text text-muted">Motivo do contato</p>
                                   <sgt-form-control-error
                                       *ngIf="motivoContato.errors && motivoContato.errors.required && motivoContato.dirty"
                                       msgError="O motivo do contato é obrigatório">
                                   </sgt-form-control-error>
                               </div>
                           </div>
                        </sgt-collapse-group>

                        <sgt-collapse-group title="Referência" [isCollapsedInDefault]="true">
                            <div class="row">
                                <div class="form-group col-12">
                                    <div class="custom-control custom-radio custom-control-inline" *ngFor="let referencia of referencias; let isFirst = first">
                                        <input type="radio" class="custom-control-input" name="referencia" id="referencia_{{entity.id ? entity.id : 0}}_{{referencia.id}}"
                                            #referenciaInput="ngModel" [value]="referencia.id" [(ngModel)]="entity.referencia" (ngModelChange)="onChangeReferencia()" required="required"
                                            [attr.disabled]="canEditReferencia == false || null" [attr.readonly]="canEditReferencia == false || null">
                                        <label class="custom-control-label" for="referencia_{{entity.id ? entity.id : 0}}_{{referencia.id}}">{{referencia.nome}}</label>

                                        <sgt-form-control-error
                                            *ngIf="isFirst && referenciaInput.errors && referenciaInput.errors.required && referenciaInput.dirty"
                                            msgError="A referência é obrigatória">
                                        </sgt-form-control-error>
                                    </div>
                                </div>
                            </div>

                            <ng-template [ngIf]="isReferenciaCliente()">
                                <div class="row">
                                    <div class="form-group col-12">
                                        <label for="cliente_{{entity.id ? entity.id : 0}}" class="col-form-label">Cliente</label>

                                        <ng-template [ngIf]="canEditClienteFn()">
                                            <sgt-typeahead-cliente [(ngModel)]="entity.cliente" name="cliente" id="cliente_{{entity.id ? entity.id : 0}}"
                                                #typeaeadCliente #cliente="ngModel" [ngControl]="cliente" [required]="!isTipoTarefa()"
                                                [exibirRevisaoPendente]="true"
                                                (entitySelected)="onClienteSelectedTypeahead($event)"
                                                (clearEntity)="onClearClienteTypeahead()">
                                            </sgt-typeahead-cliente>
                                            <p class="form-text text-muted">Informe o cliente para vincular a atividade a ele</p>
                                            <sgt-form-control-error
                                                *ngIf="cliente.errors && cliente.errors.required && cliente.dirty"
                                                msgError="O cliente é obrigatório">
                                            </sgt-form-control-error>
                                        </ng-template>

                                        <ng-template [ngIf]="!canEditClienteFn()">
                                            <div class="input-group">
                                                <div class="input-group-prepend">
                                                  <span class="input-group-text">{{entity?.cliente?.pessoa?.codigoIntegracaoErp}}</span>
                                                </div>
                                                <input type="text" class="form-control" [value]="entity?.cliente?.pessoa?.nome" disabled="disabled" readonly="readonly">
                                            </div>
                                            <p class="form-text text-muted" *ngIf="entity?.cliente">
                                                {{entity?.cliente?.pessoa?.nomeFantasia}} - {{entity?.cliente?.pessoa?.cnpjCpf}} - {{entity?.cliente?.pessoa?.enderecoPrincipal?.cidade?.nome}} - {{entity?.cliente?.pessoa?.enderecoPrincipal?.cidade?.estado?.uf}}
                                            </p>
                                        </ng-template>
                                    </div>
                                </div>

                                <div class="row mb-4" *ngIf="enderecoContatoCliente">
                                    <div class="col-12">
                                        <sgt-pessoa-endereco-info-card
                                            [endereco]="enderecoContatoCliente.endereco">
                                        </sgt-pessoa-endereco-info-card>
                                    </div>
                                </div>

                                <!-- Contatos do Cliente -->
                                <div class="row" *ngIf="entity.cliente">
                                    <div class="col-12">
                                        <sgt-pessoa-contato
                                            #pessoaContato
                                            [idTable]="pessoaContatoIdTable"
                                            [idPessoa]="entity.cliente.idPessoa"
                                            [entities]="contatosCliente"
                                            [persistSaves]="true"
                                            tableMaxHeight="140px">
                                        </sgt-pessoa-contato>
                                    </div>
                                </div>

                            </ng-template>

                            <ng-template [ngIf]="isReferenciaLead()">
                                <div class="row">
                                    <div class="form-group col-12">
                                        <label for="lead_{{entity.id ? entity.id : 0}}" class="col-form-label">Lead</label>

                                        <ng-template [ngIf]="canEditLeadFn()">
                                            <sgt-lead-typeahead [(ngModel)]="entity.lead" name="lead" id="lead_{{entity.id ? entity.id : 0}}"
                                                #leadTypeaead #lead="ngModel" [ngControl]="lead" [required]="!isTipoTarefa()"
                                                (entitySelected)="onLeadSelectedTypeahead($event)"
                                                (clearEntity)="onClearLeadTypeahead()">
                                            </sgt-lead-typeahead>
                                            <p class="form-text text-muted">Informe o lead para vincular a atividade a ele</p>
                                            <sgt-form-control-error
                                                *ngIf="lead.errors && lead.errors.required && lead.dirty"
                                                msgError="O lead é obrigatório">
                                            </sgt-form-control-error>
                                        </ng-template>

                                        <ng-template [ngIf]="!canEditLeadFn()">
                                            <div class="input-group">
                                                <!-- <div class="input-group-prepend">
                                                    <span class="input-group-text">
                                                    </span>
                                                </div> -->
                                                <input type="text" class="form-control" [value]="entity?.lead?.nome" disabled="disabled" readonly="readonly">
                                            </div>
                                            <p class="form-text text-muted" *ngIf="entity?.lead">
                                                {{entity?.lead?.nomeFantasia}}
                                            </p>
                                        </ng-template>
                                    </div>
                                </div>
                            </ng-template>

                        </sgt-collapse-group>

                        <sgt-collapse-group title="Execução" [isCollapsedInDefault]="true">
                            <div class="row">
                                <div class="form-group col-12 col-md-5 col-lg-4" *ngIf="editMode">
                                    <label class="col-form-label">Criada em</label>
                                    <input type="text" class="form-control text-center" value="{{entity.dataEmissao | date:'dd/MM/yyyy'}} às {{entity.dataEmissao | date:'HH:mm'}}" name="dataEmissao"
                                        disabled="disabled" readonly="readonly">
                                </div>
                                <div class="form-group col-12 col-md" *ngIf="isShowUsuarioOrigem()">
                                    <label for="usuarioOrigem_{{entity.id ? entity.id : 0}}" class="col-form-label">Criado Por</label>
                                    <input type="text" class="form-control" [value]="entity.usuarioOrigem?.nome" name="usuarioOrigem" id="usuarioOrigem_{{entity.id ? entity.id : 0}}"
                                        disabled="disabled" readonly="readonly">
                                </div>
                            </div>

                            <div class="row" *ngIf="entity.concluida">
                                <div class="form-group col-12 col-md-5 col-lg-4" *ngIf="entity.dataConclusao">
                                    <label class="col-form-label">Concluída Em</label>
                                    <input type="text" class="form-control text-center" value="{{entity.dataConclusao | date:'dd/MM/yyyy'}} às {{entity.dataConclusao | date:'HH:mm'}}" name="dataConclusao"
                                        disabled="disabled" readonly="readonly">
                                </div>
                                <div class="form-group col-12 col-md" *ngIf="entity.idUsuarioConclusao">
                                    <label for="usuarioConclusao_{{entity.id ? entity.id : 0}}" class="col-form-label">Concluída Por</label>
                                    <input type="text" class="form-control" [value]="entity.usuarioConclusao?.nome" name="usuarioConclusao" id="usuarioConclusao_{{entity.id ? entity.id : 0}}"
                                        disabled="disabled" readonly="readonly">
                                </div>
                            </div>

                            <div class="row" *ngIf="isShowUsuarioDestino()">
                                <div class="form-group col-12">
                                    <label for="usuarioDestino_{{entity.id ? entity.id : 0}}" class="col-form-label">Responsável</label>
                                    <!-- Pode atribuir responsável -->
                                    <span *ngIf="canAtribuirUsuarioDestino()">
                                        <sgt-usuario-select
                                            [idUsuario]="entity.idUsuarioDestino"
                                            (usuarioChange)="onTypeaheadChangeUsuarioDestino($event)"
                                            empityName="Nenhum responsável">
                                        </sgt-usuario-select>
                                        <p class="form-text text-muted">Responsável por executar este atividade. Deixei em branco para atributir a atividade a si mesmo</p>
                                    </span>

                                    <!-- Não pode atribuir responsável -->
                                    <span *ngIf="!canAtribuirUsuarioDestino()">
                                        <input type="text" class="form-control" [value]="entity.usuarioDestino?.nome" disabled="disabled" readonly="readonly">
                                    </span>
                                </div>
                            </div>
                            <div class="row data-prazo">
                                <div class="form-group col-12 col-md">
                                    <label for="diaInicio_{{entity.id ? entity.id : 0}}" class="col-form-label">Início</label>
                                    <sgt-datepicker [(ngModel)]="entity.diaInicio" name="diaInicio" id="diaInicio_{{entity.id ? entity.id : 0}}"
                                        #diaInicioModel="ngModel"  #diaInicio [ngControl]="diaInicioModel">
                                    </sgt-datepicker>
                                </div>
                                <div class="form-group col-12 col-md hora-inicio">
                                    <timepicker class="timepicker" [(ngModel)]="entity.horaInicio" [mousewheel]="false" [showMeridian]="false" [minuteStep]="1" name="horaInicio" id="horaInicio_{{entity.id ? entity.id : 0}}">
                                    </timepicker>
                                </div>

                                <ng-template [ngIf]="config?.canEditPrazo">
                                    <div class="form-group col-12 col-md">
                                        <label for="diaPrazo_{{entity.id ? entity.id : 0}}" class="col-form-label">Prazo</label>
                                        <sgt-datepicker [(ngModel)]="entity.diaPrazo" name="diaPrazo" id="diaPrazo_{{entity.id ? entity.id : 0}}"
                                            #diaPrazoModel="ngModel"  #diaPrazo [ngControl]="diaPrazoModel" required="required">
                                        </sgt-datepicker>
                                    </div>
                                    <div class="form-group col-12 col-md hora-prazo">
                                        <timepicker class="timepicker" [(ngModel)]="entity.horaPrazo" [mousewheel]="false" [showMeridian]="false" [minuteStep]="1" name="horaPrazo" id="horaPrazo_{{entity.id ? entity.id : 0}}">
                                        </timepicker>
                                    </div>
                                </ng-template>
                                <ng-template [ngIf]="!config?.canEditPrazo">
                                    <div class="form-group col-12 col-md">
                                        <label class="col-form-label">Prazo</label>
                                        <input type="text" class="form-control text-center" value="{{entity.diaPrazo | date:'dd/MM/yyyy'}} {{entity.horaPrazo ? 'às ' + (entity.horaPrazo | date:'HH:mm') : ''}}" name="diaPrazo"
                                            disabled="disabled" readonly="readonly">
                                    </div>
                                </ng-template>
                            </div>

                            <div class="row">
                                <div class="form-group col-12">
                                    <label for="comentario_{{entity.id ? entity.id : 0}}" class="col-form-label">Comentário</label>
                                    <textarea class="form-control" [(ngModel)]="entity.comentario" name="comentario" id="comentario_{{entity.id ? entity.id : 0}}"
                                        #comentario="ngModel" rows="3" sgtAutosize>
                                    </textarea>
                                </div>
                            </div>
                        </sgt-collapse-group>

                        <sgt-atividade-checklist-item
                            #atividadeChecklistItem
                            [idAtividade]="entity.id"
                            [entities]="entity.checklistItens"
                            [(quantidadeChecklistItens)]="entity.quantidadeChecklistItens"
                            [(quantidadeChecklistItensConcluidos)]="entity.quantidadeChecklistItensConcluidos"
                            [(percQuantidadeChecklistItensConcluidos)]="entity.percQuantidadeChecklistItensConcluidos">
                        </sgt-atividade-checklist-item>


                        <!-- Título -->
                        <sgt-collapse-group title="Título" [isCollapsedInDefault]="true" *ngIf="isTipoClienteTituloVencido()">
                            <div class="card mb-2">
                                <div class="card-header">
                                    <h6 class="card-title mb-0">
                                        Confira abaixo os detalhes do título desta atividade
                                    </h6>
                                </div>
                                <sgt-titulo-receber-form
                                    [id]="entity.idTituloReceber"
                                    [embedded]="true"
                                    [showCliente]="false"
                                    [showRepresentante]="false">
                                </sgt-titulo-receber-form>
                            </div>
                        </sgt-collapse-group>

                        <!-- Retorno -->
                        <sgt-collapse-group title="Retornar?" [isCollapsedInDefault]="true">
                            <sgt-atividade-retorno-form
                               #retornoForm
                               [entity]="entity"
                               (openAtividade)="openAtividadeRetorno($event)">
                            </sgt-atividade-retorno-form>
                        </sgt-collapse-group>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <div class="modal-footer-conclusao" *ngIf="entity">
                    <div *ngIf="entity.conclusaoBloqueada">
                        <i class="fas fa-lock"></i> Conclusão da atividade bloqueada
                        <p class="form-text text-muted">
                            {{entity.tipo | atividadeTipoMotivoConclusaoBloqueada}}
                        </p>
                    </div>

                    <div *ngIf="!entity.conclusaoBloqueada" class="custom-control custom-checkbox custom-checkbox-atividade-conclusao">
                        <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.concluida" name="checkboxConcluida" id="checkboxConcluida_{{entity?.id ? entity.id : 0}}">
                        <label class="custom-control-label" for="checkboxConcluida_{{entity?.id ? entity.id : 0}}">Atividade Concluída</label>
                    </div>
                </div>

                <div class="modal-footer-btns">
                    <button type="button" class="btn btn-light" (click)="cancel()">
                        <i class="fas fa-undo"></i> Cancelar
                    </button>
                    <button type="button" class="btn btn-success" (click)="save()" [disabled]="form.invalid" id="btnSaveAtividade_{{entity?.id ? entity.id : 0}}">
                        <i class="fas fa-check"></i> Salvar
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
